import React, { Component, useEffect, useState } from 'react';
import styles from './styles';
import {
  KeyboardDatePicker,
  KeyboardTimePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';
import { Button, CircularProgress } from '@material-ui/core';
import { toast } from 'react-toastify';
import moment from 'moment';
import { updateShipmentTime } from '../../stores/api';
import { withRouter } from 'react-router-dom'

const ShipmentTimeForm = (props) => {
  const [earliestDate, setEarliestDate] = useState(new Date())
  const [earliestTime, setEarliestTime] = useState(new Date())
  const [latestDate, setLatestDate] = useState(new Date())
  const [latestTime, setLatestTime] = useState(new Date())
  const [originDate, setOriginDate] = useState(new Date())

  const [localEarliestTime, setLocalEarliestTime] = useState('')
  const [localLatestTime, setLocalLatestTime] = useState('')
  const [dayDiff, setDayDiff] = useState(0)
  const [updating, setUpdating] = useState(false)

  const save = async () => {
    let startTime = ''
    let endTime = ''

    if (props.shipment.service_type !== 'COMMINGLE') {

      startTime = moment().tz(props.shipment.timezone).set({
        year: earliestDate.getFullYear(),
        month: earliestDate.getMonth(),
        date: earliestDate.getDate(),
        hour: earliestTime.getHours(),
        minute: 0,
        second: 0,
      })
      endTime = moment().tz(props.shipment.timezone).set({
        year: latestDate.getFullYear(),
        month: latestDate.getMonth(),
        date: latestDate.getDate(),
        hour: latestTime.getHours(),
        minute: 0,
        second: 0,
      })

    } else {

      startTime = moment().tz(props.shipment.timezone).set({
        year: earliestDate.getFullYear(),
        month: earliestDate.getMonth(),
        date: earliestDate.getDate(),
        hour: earliestTime.getHours(),
        minute: earliestTime.getMinutes(),
        second: earliestTime.getSeconds(),
      })

      endTime = moment().tz(props.shipment.timezone).set({
        year: latestDate.getFullYear(),
        month: latestDate.getMonth(),
        date: latestDate.getDate(),
        hour: latestTime.getHours(),
        minute: latestTime.getMinutes(),
        second: latestTime.getSeconds(),
      })
      endTime = endTime.add('days', dayDiff)
    }

    setUpdating(true)
    const res = await updateShipmentTime(props.shipment.id, {
      dropoff_earliest_ts: startTime,
      dropoff_latest_ts: endTime
    })

    if (res.ok) {
      const { regions, stores, start } = props.deliveryStore;
      const region = regions.length > 0 ? regions.join(",") : "all";
      const day = moment(start * 1000).format("YYYY-MM-DD");
      const store = stores.length > 0 ? stores.join(",") : "";
      const storeString = !!store ? `?stores=${store}` : "";
      const updatedDay = moment.tz(res.data.dropoff_earliest_ts, moment.tz.guess()).format('YYYY-MM-DD')

      if (updatedDay === day) {
        props.deliveryStore.selectedShipment.dropoff_earliest_ts = startTime
        props.deliveryStore.selectedShipment.dropoff_latest_ts = endTime
        props.deliveryStore.updateCache[props.shipment.id] = {dropoff_earliest_ts: startTime, dropoff_latest_ts: endTime}
        props.deliveryStore.applyChange_()
      } else {
        props.history.push(`/deliveries/${day}/${region}${storeString}`);
        props.deliveryStore.setSelectedShipment(null);
        props.deliveryStore.loadShipments()
      }
      const updateUrl = `/deliveries/${updatedDay}/${region}${storeString}/${props.shipment.id}`
      props.closeForm();
      toast.success(<div>Shipment updated successfully <a href={updateUrl} target='_blank' rel='noopener noreferrer'>View</a></div>);
    } else {
      if (res.data.message) {
        toast.error(res.data.message);
      } else {
        if (res.data.errors) {
          toast.error(res.data.errors[0]);
        } else {
          toast.error('Shipment cannot be updated!');
        }
      }
    }

    setUpdating(false)
  };

  const handleDateChange = (type, e) => {
    let t
    switch (type) {
      case 'earliest_date':
        t = moment().tz(props.shipment.timezone).set({
          year: e.getFullYear(),
          month: e.getMonth(),
          date: e.getDate(),
          hour: earliestTime.getHours(),
          minute: earliestTime.getMinutes(),
          second: earliestTime.getSeconds(),
        }).tz(moment.tz.guess())
        setLocalEarliestTime(t)

        setEarliestDate(e)
        const diffDays = parseInt((e - originDate) / (1000 * 60 * 60 * 24));
        setDayDiff(diffDays)
        break;
      case 'earliest_time':
        t = moment().tz(props.shipment.timezone).set({
          year: earliestDate.getFullYear(),
          month: earliestDate.getMonth(),
          date: earliestDate.getDate(),
          hour: e.getHours(),
          minute: 0,
          second: 0,
        }).tz(moment.tz.guess())
        setLocalEarliestTime(t)
        e.setMinutes(0)
        e.setSeconds(0)
        setEarliestTime(e)
        break;
      case 'latest_date':
        t = moment().tz(props.shipment.timezone).set({
          year: e.getFullYear(),
          month: e.getMonth(),
          date: e.getDate(),
          hour: latestTime.getHours(),
          minute: latestTime.getMinutes(),
          second: latestTime.getSeconds(),
        }).tz(moment.tz.guess())
        setLocalLatestTime(t)
        setLatestDate(e)
        break;
      case 'latest_time':
        t = moment().tz(props.shipment.timezone).set({
          year: latestDate.getFullYear(),
          month: latestDate.getMonth(),
          date: latestDate.getDate(),
          hour: e.getHours(),
          minute: 0,
          second: 0,
        }).tz(moment.tz.guess())
        setLocalLatestTime(t)
        e.setMinutes(0)
        e.setSeconds(0)
        setLatestTime(e)
        break;
    }


  }

  useEffect(() => {
    const startTime = moment.tz(props.shipment.dropoff_earliest_ts, props.shipment.timezone)
    const endTime = moment.tz(props.shipment.dropoff_latest_ts, props.shipment.timezone)
    const originTime = moment.tz(props.shipment.dropoff_earliest_ts, props.shipment.timezone)

    setOriginDate(new Date(originTime.get('year'), originTime.get('month'), originTime.get('date')))

    setEarliestDate(new Date(startTime.get('year'), startTime.get('month'), startTime.get('date')))
    setEarliestTime(new Date(startTime.get('year'), startTime.get('month'), startTime.get('date'),
      startTime.get('hour'), startTime.get('minute'), startTime.get('second')))

    setLatestDate(new Date(endTime.get('year'), endTime.get('month'), endTime.get('date')))
    setLatestTime(new Date(endTime.get('year'), endTime.get('month'), endTime.get('date'),
      endTime.get('hour'), endTime.get('minute'), endTime.get('second')))


    setLocalEarliestTime(moment.tz(props.shipment.dropoff_earliest_ts, moment.tz.guess()).toString())
    setLocalLatestTime(moment.tz(props.shipment.dropoff_latest_ts, moment.tz.guess()).toString())
  }, [props.shipment])

  return <div style={styles.Container}>
    <div style={styles.HeaderTitle}>{`Edit Shipment Time`}</div>
    <div style={styles.timezone}>
      <span style={{ color: '#B7B7B7' }}>Shipment timezone is</span>: {props.shipment.timezone}
    </div>
    {props.shipment.service_type === 'COMMINGLE' &&
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <div style={styles.Field}>
          <KeyboardDatePicker
            variant="inline"
            format="MM/dd/yyyy"
            margin="normal"
            id="date-picker-inline"
            label="Dropoff Date"
            value={earliestDate}
            onChange={(e) => handleDateChange('earliest_date', e)}
            KeyboardButtonProps={{
              'aria-label': 'change date',
            }}
            InputProps={{ readOnly: true }} 
          />
        </div>
      </MuiPickersUtilsProvider>
    }
    {props.shipment.service_type !== 'COMMINGLE' &&
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <div>
          <div style={styles.Field}>
            <KeyboardDatePicker
              variant="inline"
              format="MM/dd/yyyy"
              margin="normal"
              id="date-picker-inline"
              label="Dropoff Date Earliest"
              value={earliestDate}
              onChange={(e) => handleDateChange('earliest_date', e)}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              InputProps={{ readOnly: true }} 
            />

            <KeyboardTimePicker
              variant="inline"
              margin="normal"
              id="date-picker-inline"
              label="Dropoff Time Earliest"
              value={earliestTime}
              onChange={(e) => handleDateChange('earliest_time', e)}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              autoOk
              ampm={false}
              InputProps={{ readOnly: true }}               
              views={['hours']}
            />
          </div>
          <div style={styles.localTime}>Dropoff earliest local time: {localEarliestTime.toString()}</div>
        </div>
        <div>
          <div style={styles.Field}>
            <KeyboardDatePicker
              variant="inline"
              format="MM/dd/yyyy"
              margin="normal"
              id="date-picker-inline"
              label="Dropoff Date Latest"
              value={latestDate}
              onChange={(e) => handleDateChange('latest_date', e)}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              InputProps={{ readOnly: true }} 
            />

            <KeyboardTimePicker
              variant="inline"
              margin="normal"
              id="date-picker-inline"
              label="Dropoff Time Latest"
              value={latestTime}
              onChange={(e) => handleDateChange('latest_time', e)}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              autoOk
              ampm={false}
              InputProps={{ readOnly: true }}               
              views={['hours']}
            />
          </div>
          <div style={styles.localTime}>Dropoff latest local time: {localLatestTime.toString()}</div>
        </div>
      </MuiPickersUtilsProvider>
    }
    <div style={styles.buttonList}>
      <Button style={styles.cancelButton} onClick={props.closeForm}>Cancel</Button>
      <Button style={styles.saveButton} onClick={save}>{updating ? <CircularProgress style={styles.circularProgress} /> : 'Save'}</Button>
    </div>
  </div>

}

export default withRouter(ShipmentTimeForm);
